import { Select } from 'antd';
import React from 'react';

const SelectorInput = ({
  value,
  onChange,
  options = [],
  disabled = false,
  placeholder = 'Sélectionnez une valeur',
}) => {
  const normalizedValue =
    value == null || value === '' ? [] : Array.isArray(value) ? value : [value];

  return (
    <Select
      mode="multiple"
      value={normalizedValue}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      style={{ width: '100%' }}
      showSearch
      optionFilterProp="label"
      allowClear
      options={options.map((opt) => ({
        value: opt.code,
        label: `${opt.label} (${opt.code})`,
      }))}
    />
  );
};

export default SelectorInput;
